import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';
import { GhoreTable } from '../tables/ghore/GhoreTable'
import { GhorePrizePage } from './GhorePrizePage'

import { SelectPrizeForGhore } from '../tables/selectPrizeForGhore/SelectPrizeForGhore'
import { CeremonyTable } from '../tables/ceremony/CeremonyTable'

export class CeremonyPage extends Component {


    constructor(props) {
        super(props);
        this.state = { currentCount: 0, isLoading: false };
        this.state.data = {};

        this.onHideMasterPage = this.onHideMasterPage.bind(this);

        this.onAddCeremony = this.onAddCeremony.bind(this);

        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token
        };
    }




    onHideMasterPage(data) {

        if (typeof this.props.onHideMasterPage === "function") {
            this.props.onHideMasterPage(data);

        }

    }
    onAddCeremony() 
    {
        this.setState({ isLoading:true });
        console.log("onAddCeremony");
        this.setState({ mode: "" });

        setTimeout(
            function () {
                this.setState({ isLoading:false });

            }
                .bind(this),
            500
        );
 
    }



    render() {
        if (this.state.isLoading) {
            return <div>...</div>
        }



        return (
            <div>
                <CeremonyTable ghoreId={this.props.ghoreId} onStartClick={this.onHideMasterPage} onDisable={this.onAddCeremony} />
                <SelectPrizeForGhore ghoreId={this.props.ghoreId} onAdd={this.onAddCeremony} onHideMasterPage={this.onHideMasterPage}></SelectPrizeForGhore>
            </div>
        )


    }
}



// WEBPACK FOOTER //
// ./src/components/CeremonyPage.js